function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { Container } from '../../atoms';
import { SectionHeader, DonationBox } from '../../molecules';
import ReactConfigContext from '../../ReactConfigContext';
export default function DonationBoxSection(props) {
    var title = props.title, subtitle = props.subtitle, image = props.image, donationBox = props.donationBox, onPeriodChange = props.onPeriodChange, onSelectValue = props.onSelectValue, className = props.className;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement(Container, {
        containerClassName: "max-w-xl",
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-6 md:gap-9"
    }, !!(title || subtitle) && /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title,
        subtitle: subtitle,
        className: "max-w-none"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-6 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-rows-1 order-last md:order-first"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        className: twMerge('w-full h-full object-cover object-center rounded-xl safari-fix-transform', image.className)
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(DonationBox, _object_spread_props(_object_spread({}, donationBox), {
        onPeriodChange: onPeriodChange,
        onSelectValue: onSelectValue
    }))))));
}

//# sourceMappingURL=DonationBoxSection.js.map